import React from 'react';

const Socials = () => {
  return (
    <section className="w-full bg-[#FFFF00] text-black text-center py-10">
      <h2 className="text-[48px] font-bold mb-4 mq450:text-[24px]">OBCZAJ SOCIALE</h2>
      <div className="flex justify-center gap-6 flex-wrap max-w-[640px] mx-auto">
        <a href="https://youtube.com/@obczajam" target="_blank" rel="noopener noreferrer">
          <img src="/social/youtube.png" alt="YouTube" className="w-[120px] h-[120px] mq450:w-[64px] mq450:h-[64px] transition-transform hover:scale-110 hover:brightness-110" />
        </a>
        <a href="https://instagram.com/isupermwk" target="_blank" rel="noopener noreferrer">
          <img src="/social/instagram.png" alt="Instagram" className="w-[120px] h-[120px] mq450:w-[64px] mq450:h-[64px] transition-transform hover:scale-110 hover:brightness-110" />
        </a>
        <a href="https://tiktok.com/@emwuczka" target="_blank" rel="noopener noreferrer">
          <img src="/social/tiktok.png" alt="TikTok" className="w-[120px] h-[120px] mq450:w-[64px] mq450:h-[64px] transition-transform hover:scale-110 hover:brightness-110" />
        </a>
      </div>
      <p className="text-[24px] mt-6 font-bold mq450:text-[20px]">WKRÓTCE WIĘCEJ</p>
      <p className="text-[24px] mt-2 font-bold mq450:text-[16px]">#doubleyes</p>
    </section>
  );
};

export default Socials;